/**
 * Full Experience Animation styles (web)
 *
 * Styles specific to the FullExperienceAnimation variant:
 * glass overlays, reading phase, Y2K elements, glitch text, continue button.
 */

import { StyleSheet, Platform } from 'react-native';
import { Y2K_GRADIENT_COLORS } from './types';

const sheetStyles = StyleSheet.create({
  glassOverlayTop: {
    position: 'absolute', top: 0, left: 0, right: 0, height: 100, zIndex: 10,
  },
  glassOverlayBottom: {
    position: 'absolute', bottom: 0, left: 0, right: 0, height: 100, zIndex: 10,
  },
  focusGlowZone: {
    position: 'absolute', left: 0, right: 0, height: 60, top: '50%',
    transform: [{ translateY: -30 }], zIndex: 5,
  },
  readingContainer: {
    position: 'absolute', left: 0, right: 0, top: '50%', width: '100%',
    alignItems: 'center', paddingHorizontal: 32,
  },
  readingLine: {
    fontSize: 16, fontWeight: '500', color: '#d0d0d8', textAlign: 'center',
    lineHeight: 38, height: 38, display: 'flex',
    alignItems: 'center', justifyContent: 'center', paddingHorizontal: 24,
  },
  readingLineFocused: {
    fontSize: 17, fontWeight: '600', color: '#FFFFFF', transform: [{ scale: 1.02 }],
  },
  y2kProgressBar: { height: '100%', borderRadius: 2 },
  topLoaderContainer: {
    position: 'absolute', top: 0, left: 0, right: 0, height: 3,
    backgroundColor: 'rgba(255, 255, 255, 0.05)', zIndex: 10,
  },
  topLoaderBar: { height: '100%', borderRadius: 0 },
  glitchProgressContainerInsideGradient: {
    position: 'absolute', top: 12, right: 0, alignItems: 'flex-end',
    zIndex: 100, paddingRight: 24,
  },
  glitchProgressContainer: {
    position: 'absolute', bottom: 80, right: 24, alignItems: 'flex-end',
  },
  glitchProgressText: {
    fontFamily: Platform.OS === 'web' ? 'Courier New, monospace' : 'Courier',
    fontSize: 12, fontWeight: '700', color: Y2K_GRADIENT_COLORS.lavender,
    letterSpacing: 2, textTransform: 'uppercase',
  },
  glitchLayerR: {
    position: 'absolute', color: Y2K_GRADIENT_COLORS.pink, opacity: 0.5,
    transform: [{ translateX: -1 }, { translateY: 0.5 }],
  },
  glitchLayerB: {
    position: 'absolute', color: Y2K_GRADIENT_COLORS.mint, opacity: 0.5,
    transform: [{ translateX: 1 }, { translateY: -0.5 }],
  },
  continueButtonGradient: {
    paddingHorizontal: 32, paddingVertical: 14, borderRadius: 24,
    borderWidth: 1, borderColor: 'rgba(255, 255, 255, 0.2)',
  },
});

// Web-only styles with CSS properties not in React Native's type system.
// Using `as const` on string-literal props to preserve narrow types.
const continueButton = {
  position: 'absolute' as const, bottom: 60, borderRadius: 24, overflow: 'hidden' as const,
  boxShadow: '0px 4px 12px rgba(212, 165, 255, 0.4)',
  zIndex: 9999, pointerEvents: 'auto' as const,
};
const continueButtonText = {
  fontSize: 16, fontWeight: '600' as const, color: '#FFFFFF', textAlign: 'center' as const,
  letterSpacing: 0.5, textShadow: '0px 0px 8px rgba(212, 165, 255, 0.6)',
};

export const fullExperienceStyles = { ...sheetStyles, continueButton, continueButtonText };
